import { useEffect, useState } from 'react'
import { fetchPlace } from '../api/place'
import type { Place } from '../types/display'

export function usePlace(placeId: string): Place | null {
  const [place, setPlace] = useState<Place | null>(null)

  useEffect(() => {
    let current = true
    void fetchPlace(placeId).then((value) => {
      // `value` is `null` when the read failed or the record is unusable —
      // keep that distinct from "read succeeded, place has no logo" so
      // callers (e.g. useShopLogo) don't treat a transient failure as
      // confirmation the place has nothing to show.
      if (current) setPlace(value)
    })
    return () => {
      current = false
    }
  }, [placeId])

  return place
}
